const wowApp = require('angular').module('wowApp.common');
const wzButtons = require('./wizard-buttons-directive');

wowApp.service('WizardRegistry', require('./wizard-registry-service'));

wowApp.directive('olyWizard', require('./wizard-directive'));
wowApp.directive('olyWzStep', require('./wizard-step-directive'));

wowApp.directive('olyWzNext', wzButtons.next);
wowApp.directive('olyWzPrevious', wzButtons.previous);
wowApp.directive('olyWzFinish', wzButtons.finish);
wowApp.directive('olyWzCancel', wzButtons.cancel);
wowApp.directive('olyWzRestart', wzButtons.restart);


/** WEBPACK FOOTER **
 ** ./wowapp/src/common/components/wizard/index.js
 **/